import { capEditPrimaryApi, execute } from '@/utils/api';
import type {
  EntityAdministrationalPrimaryMember,
  EntityAdministrationalPrimaryOrganization,
  EntitySuccessMsg
} from '@/utils/api/maintenance/api';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const usePrimaryStore = defineStore(
  'primary',
  () => {
    /** 一次専門組織 - 検索条件（サービス） */
    const serviceId = ref<number | undefined>(undefined);

    /* 一次専門組織 - 検索条件（組織名称） */
    const organizationName = ref<string | undefined>(undefined);

    /** 一次専門組織 - リスト */
    const organizations = ref<EntityAdministrationalPrimaryOrganization[]>([]);

    /** 一次専門組織 - 総件数 */
    const organizationTotal = ref<number>(0);

    /** 一次専門組織 - ページネーション */
    const itemsPerPage = ref<number>(25);
    const page = ref<number>(1);

    /** 一次専門組織リストを取得する */
    const fetchOrganizations = (
      serviceId: number,
      pageMax: number,
      pageNum: number,
      name?: string
    ): Promise<any> => {
      return execute(
        () => capEditPrimaryApi.getPrimaryOrganizations(serviceId, pageMax, pageNum, name),
        true
      )
        .then((data: { total: number; items: EntityAdministrationalPrimaryOrganization[] }) => {
          console.info('一次専門組織 一覧取得成功');

          // 一次専門組織リストを更新
          organizations.value = data.items;
          // 総件数を更新
          organizationTotal.value = data.total;
        })
        .catch((e: unknown) => {
          console.warn('一次専門組織 一覧取得失敗');
          organizations.value = [];
          organizationTotal.value = 0;
        });
    };

    /** 一次専門組織を更新する */
    const updateOrganization = (
      id: number,
      organization: EntityAdministrationalPrimaryOrganization
    ): Promise<any> => {
      return new Promise((resolve, reject) => {
        execute(() => capEditPrimaryApi.updatePrimaryOrganization(id, organization), true)
          .then((data: EntityAdministrationalPrimaryOrganization) => {
            console.info('一次専門組織 更新成功');
            // リストを更新する
            const index = organizations.value.findIndex((v) => v.organizationId === id);
            if (index != -1) {
              organizations.value[index] = data;
            }
            resolve(data);
          })
          .catch((e: unknown) => {
            console.warn('一次専門組織 更新失敗');
            reject();
          });
      });
    };

    /** 一次専門組織を削除する  */
    const deleteOrganization = (id: number): Promise<void> => {
      return new Promise((resolve, reject) => {
        execute(() => capEditPrimaryApi.deletePrimaryOrganization(id), true)
          .then((data: EntitySuccessMsg[]) => {
            console.info('一次専門組織 削除成功');
            // リストから削除する
            const index = organizations.value.findIndex((v) => v.organizationId === id);
            if (index != -1) {
              organizations.value.splice(index, 1);
            }
            resolve();
          })
          .catch((e: unknown) => {
            console.warn('一次専門組織 削除失敗');
            reject();
          });
        // .finally(() => {});
      });
    };

    /**
     * IDから一次専門組織を取得する
     * @param id
     * @returns EntityAdministrationalPrimaryOrganization 一次専門組織
     */
    const getOrganizationById = (
      id: number
    ): EntityAdministrationalPrimaryOrganization | undefined => {
      return organizations.value.find((v) => v.organizationId === id);
    };

    // 一次専門組ユーザー _ 新規登録 _ ユーザー部格納
    const PUstore = ref<EntityAdministrationalPrimaryMember | undefined>(undefined);

    /** 一次専門組織ユーザ - 検索条件（ユーザー名） */
    const memberId = ref<string | undefined>(undefined);

    /* 一次専門組織ユーザ - 検索条件（E-mail） */
    const Email = ref<string | undefined>(undefined);

    /** 一次専門組織ユーザー - リスト */
    const members = ref<EntityAdministrationalPrimaryMember[]>([]);

    /** 一次専門組織ユーザー - 総件数 */
    const memberTotal = ref<number>(0);

    // 新規登録 - 編集 - ユーザ名の表記処理
    const username = ref<boolean>(false);

    // パスワード変更
    const passchange = ref<boolean>(false);

    /** 一次専門組織ユーザの一覧を取得する */
    const fetchMembers = (
      organizationId: number,
      pageMax: number,
      pageNum: number,
      name_user: string,
      email: string
    ) => {
      return execute(
        () =>
          capEditPrimaryApi.getPrimaryOrganizationMembers(
            organizationId,
            pageMax,
            pageNum,
            name_user?.length ? name_user : undefined,
            email?.length ? email : undefined
          ),
        true
      )
        .then((data: { total: number; items: EntityAdministrationalPrimaryMember[] }) => {
          console.info(' ユーザー 一覧取得成功');

          // ユーザーリストを更新
          members.value = data.items;
          // 総件数を更新
          memberTotal.value = data.total;
        })
        .catch((e: unknown) => {
          console.warn('ユーザー 一覧取得失敗');
          members.value = [];
          memberTotal.value = 0;
        });
      // .finally(() => {
      //   console.warn('ユーザー 一覧取得成功');
      //   members.value = [
      //     {
      //       memberId: 1,
      //       name: '一次 太郎',
      //       email: 'test@example.com',
      //       sub: '77f49aa8-d0b1-70de-3b4d-f1e1d4c5aad2',
      //       tel: 'string',
      //       password: null,
      //       createdAt: '2024-12-19T00:37:41.808Z',
      //       updatedAt: '2024-12-19T00:37:41.808Z',
      //       updatedById: 1,
      //       updatedByName: '管理 太郎'
      //     }
      //   ];
      //   memberTotal.value = 1;
      //   PUstore.value = {
      //     memberId: 1,
      //     name: '一次 太郎',
      //     email: 'test@example.com',
      //     sub: '77f49aa8-d0b1-70de-3b4d-f1e1d4c5aad2',
      //     tel: 'string',
      //     password: null,
      //     createdAt: '2024-12-19T00:37:41.808Z',
      //     updatedAt: '2024-12-19T00:37:41.808Z',
      //     updatedById: 1,
      //     updatedByName: '管理 太郎'
      //   };
      // });
    };

    // 一次専門組織ユーザを更新する
    const updateMember = (
      organizationId: number,
      MemberId: number,
      member: EntityAdministrationalPrimaryMember
    ): Promise<void> => {
      return new Promise((resolve, reject) => {
        execute(
          () => capEditPrimaryApi.updatePrimaryOrganizationMember(organizationId, MemberId, member),
          true
        )
          .then((data: EntityAdministrationalPrimaryMember) => {
            console.info('一次専門組織ユーザ 更新成功');
            // リストを更新する
            const index = members.value.findIndex((v) => v.memberId === MemberId);
            if (index != -1) {
              members.value[index] = data;
            }
            resolve();

            PUstore.value = data;
          })
          .catch((e: unknown) => {
            console.warn('一次専門組織ユーザ 更新失敗');
            reject();
          });
        // mock処理
        // .finally(() => {
        //   console.info('一次専門組織ユーザ 更新成功');
        //   // リストを更新する
        //   const index = members.value.findIndex((v) => v.memberId === MemberId);
        //   if (index != -1) {
        //     members.value[index] = {
        //       memberId: 1,
        //       name: '一次 太郎',
        //       email: 'test@example.com',
        //       sub: '77f49aa8-d0b1-70de-3b4d-f1e1d4c5aad2',
        //       tel: 'string',
        //       password: null,
        //       createdAt: '2024-12-19T00:50:31.962Z',
        //       updatedAt: '2024-12-19T00:50:31.962Z',
        //       updatedById: 1,
        //       updatedByName: '管理 太郎'
        //     };
        //     PUstore.value = {
        //       memberId: 1,
        //       name: '一次 太郎',
        //       email: 'test@example.com',
        //       sub: '77f49aa8-d0b1-70de-3b4d-f1e1d4c5aad2',
        //       tel: 'string',
        //       password: null,
        //       createdAt: '2024-12-19T00:50:31.962Z',
        //       updatedAt: '2024-12-19T00:50:31.962Z',
        //       updatedById: 1,
        //       updatedByName: '管理 太郎'
        //     };
        //     resolve();
        //   }
        // });
      });
    };

    /** 一次専門組織ユーザを削除する  */
    const deletePrimaryOrganizationMember = (
      organizationId: number,
      MemberId: number
    ): Promise<void> => {
      return new Promise((resolve, reject) => {
        execute(
          () => capEditPrimaryApi.deletePrimaryOrganizationMember(organizationId, MemberId),
          true
        )
          .then((data: EntitySuccessMsg[]) => {
            console.info('一次専門組織ユーザ 削除成功');
            // リストから削除する
            const index = members.value.findIndex((v) => v.memberId === MemberId);
            if (index != -1) {
              members.value.splice(index, 1);
            }
            resolve();
          })
          .catch((e: unknown) => {
            console.warn('一次専門組織ユーザ 削除失敗');
            reject();
          });
        // .finally(() => {
        //   console.info('一次専門組織ユーザー 削除成功');
        //   // リストから削除する
        //   const index = members.value.findIndex((v) => v.memberId === MemberId);
        //   if (index != -1) {
        //     members.value.splice(index, 1);
        //   }
        //   resolve();
        // });
      });
    };

    /**
     * IDから一次専門組織ユーザーを取得する
     * @param id
     * @returns EntityAdministrationalPrimaryMember 一次専門組織ユーザー
     */
    const getMemberById = (id: number): EntityAdministrationalPrimaryMember | undefined => {
      return members.value.find((v) => v.memberId === id);
    };

    /** 詳細画面に表示する一次専門組織 */
    const selectedOrganization = ref<EntityAdministrationalPrimaryOrganization | undefined>(
      undefined
    );

    /**
     * storeの初期化
     */
    const clear = (): void => {
      serviceId.value = undefined;
      organizationName.value = undefined;
      organizations.value = [];
      organizationTotal.value = 0;
      itemsPerPage.value = 25;
      page.value = 0;

      memberId.value = undefined;
      Email.value = undefined;
      PUstore.value = undefined;
      members.value = [];
      memberTotal.value = 0;
      username.value = false;
      passchange.value = false;
      selectedOrganization.value = undefined;
    };

    return {
      serviceId,
      organizationName,
      organizations,
      organizationTotal,
      itemsPerPage,
      page,
      fetchOrganizations,
      getOrganizationById,
      updateOrganization,
      deleteOrganization,
      memberId,
      Email,
      PUstore,
      members,
      memberTotal,
      fetchMembers,
      updateMember,
      deletePrimaryOrganizationMember,
      getMemberById,
      username,
      passchange,
      selectedOrganization,
      clear
    };
  },
  { persist: { storage: sessionStorage } }
);
